import type { CommunityDetail } from 'models';
import { usePermissions } from 'permissions';
import { Card, Icon } from 'ui';
import { AssetsHeaderButtons, AssetsTable, useAssetsFoldersParents } from 'features/assets';

type P = {
  community: CommunityDetail;
};

const Assets = ({ community }: P) => {
  const { canManageCommunityAssets } = usePermissions();
  const { addParentFolder, lastParentFolder, navigateToParentFolder, navigateToRoot, parents } =
    useAssetsFoldersParents();
  const canManage = canManageCommunityAssets({ community });

  return (
    <Card
      extra={canManage ? <AssetsHeaderButtons communityId={community.id} parentId={lastParentFolder?.id} /> : null}
      title={<Card.Title icon={<Icon icon="folder-line" />}>Files</Card.Title>}
    >
      <AssetsTable
        canManage={canManage}
        filter={{ communityId: community.id }}
        folders={parents}
        onNavigateToParentFolder={navigateToParentFolder}
        onNavigateToRoot={navigateToRoot}
        onOpenFolder={addParentFolder}
        parentFolder={lastParentFolder}
      />
    </Card>
  );
};

export default Assets;
